import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/producto';
import Productos from './productoList';


const ms2p = (state) => {
  return {
    ...state.productos_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Productos);
